import StencilHTMLElement from "./stencil-element";

class OffcanvasMenuItem extends StencilHTMLElement {
  name = "OffcanvasMenuItem";

  constructor() {
    super();
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.toggleSubmenu);
  }

  // Can I use toggle instead of add/remove?
  toggleSubmenu(e) {
    const togglePanelSelector = e.currentTarget.getAttribute('data-toggle-panel');
    const panel = document.querySelector(togglePanelSelector);
  
    if (!panel) return;
  
    const isHidden = panel.classList.contains('d-none');
  
    if (isHidden) {
      // Reveal panel with slide-in
      panel.classList.remove('d-none', 'slide-out');
      panel.classList.add('slide-in');
    } else {
      // Hide panel with slide-out, then hide it
      panel.classList.remove('slide-in');
      panel.classList.add('slide-out');
  
      setTimeout(() => {
        panel.classList.add('d-none');
      }, 300); // duration should match your CSS animation
    }
  }

}

export default OffcanvasMenuItem;
